import React from 'react';
import PropTypes from 'prop-types';
const OktaAuthenticationError = _ref => {
  let {
    error
  } = _ref;
  if (error.name && error.message) {
    return /*#__PURE__*/React.createElement("p", null, error.name, ": ", error.message);
  }
  return /*#__PURE__*/React.createElement("p", null, __('Error'), ": ", error.toString());
};
OktaAuthenticationError.propTypes = {
  error: PropTypes.object.isRequired
};
export default OktaAuthenticationError;